import { CoreUnderivedEventData } from 'pubsub/core'
import { isCoreClickData } from 'utils/sendCoreAPIEvent'

export const coreEventIsValid = (coreEvent: CoreUnderivedEventData) => {
  const { coreClickData, property, activity, component } = coreEvent

  const coreClickDataValid = !coreClickData || isCoreClickData(coreClickData)

  const validationResults = {
    activityValid: typeof activity === 'string',
    propertyValid: typeof property === 'string',
    coreClickDataValid: coreClickDataValid,
    componentValid: typeof component === 'string'
  }
  const paramsValid = validationResults.activityValid &&
    validationResults.propertyValid &&
    validationResults.coreClickDataValid &&
    validationResults.componentValid

  return {
    valid: paramsValid,
    results: validationResults
  }
}
